export const modalZIndex = {
  'ugc-review-dt-all-images-modal': 9999,
  'ugc-qna-answer-modal': 10000,
  'ugc-review-all-images-detail-modal': 10000,
  'ugc-review-single-image-modal': 10000,
  'ugc-review-medal-modal': 10001,
  'ugc-report-operate-modal': 10001,
  'ugc-review-rewarded-review-modal': 10001,
  'ugc-info-toolTip': 10001,
  'ugc-share-modal': 10002,
  'share-widget-layer': 10002,
  'ugc-px-modal': 10002,
  'ugc-report-abuse-modal': 10002,
  'ugc-top-review-modal': 1006,
};
